import { jsx as r } from "react/jsx-runtime";
import { useState as l, useEffect as S } from "react";
import n from "./search-block.module.less.js";
import { Search as g } from "../../elements/search-components/search/search.js";
import { useSearchQuery as L } from "../../../react-query-queries/use-search-query.js";
import { useDebounce as T } from "../../../hooks/useDebounce.js";
import { shouldShowSearchLoader as w } from "../../../helpers/search-helper.js";
const R = ({ searchTermFromParams: o, currentLanguage: i, siteId: m, onSearchChange: s }) => {
  const [e, t] = l(""), a = T(e);
  S(() => {
    t(o ?? "");
  }, [o]);
  const {
    data: d,
    isLoading: h,
    error: u
  } = L(a, i, m), p = w(h, e, a), f = (c) => {
    typeof s == "function" && s(c, !0), t(c);
  };
  return /* @__PURE__ */ r("section", { className: n.wrapper, children: /* @__PURE__ */ r("div", { className: [n.innerWrapper, "max-width padded-sides"].join(" "), children: /* @__PURE__ */ r(
    g,
    {
      isOpen: !0,
      isLoadingSearchResults: p,
      results: d,
      searchTerm: e,
      hasError: !!u,
      onChangeSearchTerm: f
    }
  ) }) });
};
export {
  R as SearchBlock,
  R as default
};
